import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { COMPANY_FLAG_API_SERVICE_TOKEN } from '@nk/api-lib';
import { CompanyFlagTypeEntity, isCompanyFlagTypeEntityArray } from '@nk/data-entities-lib';
import { EntityWithUuid, NkCardListItemAbstractComponent, SpinnerComponent } from '@nk/ui-lib';
import { Observable, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyFlagTagComponent } from '../company-flag-tag/company-flag-tag.component';

@Component({
  selector: 'nk-company-flags-card-list-item',
  imports: [CommonModule, TranslateModule, SpinnerComponent, CompanyFlagTagComponent],
  templateUrl: './company-flags-card-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyFlagsCardListItemComponent<
  Entity extends EntityWithUuid,
> extends NkCardListItemAbstractComponent<Entity> {
  public companyFlagTypes$: Observable<CompanyFlagTypeEntity[]> = this.value$.pipe(
    switchMap((value) => {
      if (value && value.entity && value.prop) {
        const item = value.entity && value.entity[value.prop];
        if (typeof item === 'string') {
          return this._companyFlagService.companyFlagHistoryCompositeByCompanyCache
            .get(item)
            .pipe(map((data) => data.map((i) => i.company_flag_type)));
        } else if (isCompanyFlagTypeEntityArray(item)) {
          return of(item);
        }
      }
      return of([]);
    }),
  );
  private _companyFlagService = inject(COMPANY_FLAG_API_SERVICE_TOKEN);
}
